import { createActions } from 'reduxsauce'

const { Types, Creators } = createActions({
  fetchTariffList: ['filter', 'offset'],
  fetchTariffListLoading: null,
  fetchTariffListLoadingMore: null,
  fetchTariffListSuccess: ['offset', 'tariffs', 'nextOffset'],
  fetchTariffListFail: ['error'],

  createTariff: ['tariff'],
  createTariffLoading: null,
  createTariffSuccess: ['tariff'],
  createTariffFail: ['error'],

  updateTariff: ['tariffID', 'tariff'],
  updateTariffLoading: null,
  updateTariffSuccess: ['tariff'],
  updateTariffFail: ['error'],

  deleteTariff: ['tariffID'],
  deleteTariffLoading: null,
  deleteTariffSuccess: ['tariffID'],
  deleteTariffFail: ['error'],

  fetchTariffsCount: ['filter'],
  fetchTariffsCountLoading: null,
  fetchTariffsCountSuccess: ['count'],
  fetchTariffsCountFail: ['error'],

  resetTariffs: null,
  resetFilter: null,
})

export const TariffTypes = Types
export default Creators
